module.exports = "/images/viluu-wordmark.svg?a31a01a027c8c336adbca3e4eb9ccc8a";